import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Box } from '@mui/material'
import { GameVariantTabViews, RouletteStandsTable, RpStandsTable } from '../../components'
import { EGameVariant } from '../../constants/gameVariant'

const Stands: FC = observer(() => {
  const content = {
    [EGameVariant.ROULETTE]: <RouletteStandsTable />,
    [EGameVariant.RUSSIAN_POKER]: <RpStandsTable />,
  }

  return (
    <Box>
      <GameVariantTabViews tabContent={content} />
    </Box>
  )
})

export default Stands
